import React, { useEffect, useRef, useState } from "react";
import { pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `/pdfjs/pdf.worker.min.mjs`;

const PdfViewer = ({ pdfBlob }) => {
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);

  useEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.clientWidth);
    }
    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.clientWidth);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const renderPdf = async () => {
      if (!pdfBlob || !(pdfBlob instanceof Blob)) {
        console.error("pdfBlob is not a Blob:", pdfBlob);
        return;
      }
      if (!containerRef.current) return;

      containerRef.current.innerHTML = "";

      const reader = new FileReader();
      reader.onload = async () => {
        const arrayBuffer = reader.result;
        const loadingTask = pdfjs.getDocument({ data: arrayBuffer });
        try {
          const pdf = await loadingTask.promise;
          for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
            const page = await pdf.getPage(pageNumber);

            const viewport = page.getViewport({ scale: 1 });

            const scale = containerWidth / viewport.width;
            const scaledViewport = page.getViewport({ scale });

            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            canvas.height = scaledViewport.height;
            canvas.width = scaledViewport.width;

            containerRef.current.appendChild(canvas);

            const renderContext = {
              canvasContext: context,
              viewport: scaledViewport,
            };
            await page.render(renderContext).promise;
          }
        } catch (error) {
          console.error("Error rendering PDF:", error);
        }
      };
      reader.readAsArrayBuffer(pdfBlob);
    };

    if (containerWidth > 0) {
      renderPdf();
    }
  }, [pdfBlob, containerWidth]);

  return (
    <div
      ref={containerRef}
      style={{
        width: "100%",
        height: "auto",
        overflow: "hidden",
      }}
    />
  );
};

export default PdfViewer;
